import React from "react";
import explore from "../../assets/explore.png";
import Vector1 from "../../assets/Vector1.png";
import "../../styles/Home.css";
import { Link } from "react-router-dom";
import Repairs from "../Repairs";
import one from "../../assets/1.png";
import two from "../../assets/2.png";
import three from "../../assets/3.png";
import four from "../../assets/4.png";
import five from "../../assets/5.png";
import six from "../../assets/6.png";
import seven from "../../assets/7.png";

import eight from "../../assets/8.png";
import nine from "../../assets/9.png";
import ten from "../../assets/10.png";
import elv from "../../assets/11.png";
import twi from "../../assets/12.png";
import thrity from "../../assets/13.png";
import fourty from "../../assets/14.png";
import { useTranslation } from "react-i18next";

const Main = () => {
  const { t, i18n } = useTranslation();

  const { language } = i18n;

  return (
    <div className="relative px-20 max-lg:px-5 Main">
      <div className="text-center">
        <h1 className="text-[#14294F] text-5xl max-lg:text-2xl font-bold mt-16 max-lg:mt-10 leading-relaxed lg:mx-24">
          {t("WANT_TO_BREAK_FREE")}
        </h1>
        <img
          src={Vector1}
          alt="Vector"
          className="absolute -left-2 top-28 w-[340px] h-[430px] max-lg:hidden"
        />
        <p className="text-[#737E91] text-2xl max-lg:text-lg mt-5 lg:mx-72">
          {t("LEAVE_THE_HARD_WORK")}
        </p>

        <div className="explore mx-auto mb-5 mt-8 py-3">
          <img
            src={explore}
            alt="explore"
            className="img-fluid mx-auto"
            width="25px"
          />
        </div>

        <Link
          to="/services"
          className="text-[#FE9B71] rounded-3xl border-2 border-[#FE9B71] w-[250px] max-lg:w-[200px] h-[55px] max-lg:h-[50px] text-2xl max-lg:text-lg flex items-center justify-center font-semibold mx-auto"
        >
          {t("BOOK_NOW")}
        </Link>
      </div>

      <div className="mt-44 max-lg:mt-14 relative">
        <h3 className="text-[#14294F] text-3xl max-lg:text-lg font-semibold">
          {t("FROM_REPAIRS_TO_ENHANCEMENTS")}
        </h3>
        <p className="text-[#737E91] text-lg mt-2">
          {t("DISCOVER_OUR_SERVICES")}
        </p>
        <div>
          <Repairs
            image={one}
            loaction="-left-28 max-lg:-left-10 top-24 max-lg:top-36"
          />
          <Repairs image={two} loaction="-left-28 max-lg:-left-10 top-96" />

          <Repairs image={three} loaction={`left-10 ${language == "en" ? "max-lg:left-20" : "max-lg:left-5"} top-56`} />

          <Repairs
            image={four}
            loaction="left-56 max-lg:left-20 top-24 max-lg:top-32"
          />
          <Repairs image={five} loaction="left-48 top-80" />

          <Repairs
            image={six}
            loaction={`left-1/2 ${language == "en" ? "max-lg:left-72 max-lg:top-26" : "max-lg:right-60 max-lg:top-14"} top-0 `}
          />
          <Repairs image={seven} loaction={`left-1/3 ${language == "en" ? "max-lg:left-40" : "max-lg:left-32"} top-56`} />

          <Repairs
            image={eight}
            loaction={`${language == "en" ? "right-72" : "left-72"} max-lg:right-68 -top-32 max-lg:top-60`}
          />
          <Repairs
            image={nine}
            loaction="right-96 max-lg:right-56 top-40 max-lg:top-80"
          />
          <Repairs
            image={ten}
            loaction="right-80 max-lg:right-44 top-80 max-lg:top-96"
          />
          <Repairs
            image={elv}
            loaction={`${language == "en" ? "right-28 -top-10" : "left-96 top-0"} max-lg:right-20 -top-10 max-lg:top-32`}
          />
          <Repairs
            image={twi}
            loaction={`right-44 ${language == "en" ? "max-lg:right-2" : "max-lg:right-14"} top-40 max-lg:top-56`}
          />
          <Repairs image={thrity} loaction="-right-28 max-lg:-right-9 top-24" />
          <Repairs
            image={fourty}
            loaction="right-5 max-lg:right-0 top-64 max-lg:top-96"
          />
        </div>
        <div className="flex justify-center items-center text-center mt-96">
          <Link
            to="/previewrequests"
            className="text-[#FDB495] text-xl border-2 border-[#FDB495] w-[200px] py-3 px-5 font-semibold"
            style={{ borderRadius: "50%" }}
          >
            {t("FIX_ANYTHING_ANYTIME")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Main;
